import './CustomButton.css';
import React from 'react';
const CustomButton = ({
  id,
  variant,
  imageSource,
  text,
  onClick,
  isDisable,
  isSelected,
}) => {
  return (
    <div
      className={`imageButton ${isSelected ? variant + 'Selected' : variant} ${
        isDisable && 'disabledButton'
      }`}
      onClick={onClick}
      key={id}
      id={id}
      disabled={isDisable}
      onKeyUp={() => {}}
    >
      {imageSource}
      <div className={variant + 'Text'}>{text}</div>
    </div>
  );
};

export default CustomButton;
